import { render, staticRenderFns } from "./HotelBookings.vue?vue&type=template&id=44c3b57f&scoped=true"
import script from "./HotelBookings.vue?vue&type=script&lang=js"
export * from "./HotelBookings.vue?vue&type=script&lang=js"
import style0 from "./HotelBookings.vue?vue&type=style&index=0&id=44c3b57f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c3b57f",
  null
  
)

export default component.exports